import React, { createContext, useRef, useState } from "react";

const defaultState = {};

const FASTPContext = createContext(defaultState);

const FASTPProvider = ({ children }) => {
  const [providers, setProviders] = useState([]);
  const [showFASTPModal, setShowFASTPModal] = useState(false);
  const [zipCode, setZipCode] = useState("");
  const [originalLatitude, setOriginalLatitude] = useState(null);
  const [originalLongitude, setOriginalLongitude] = useState(null);
  const [distance, setDistance] = useState(null);
  const [searchSeed, setSearchSeed] = useState(null);
  const [formReset, setFormReset] = useState(() => () => {});
  const [fastpModalCallback, setFastpModalCallback] = useState(() => () => {});

  const openFASTPModal = (resetFn, callbackFn) => {
    if (resetFn) {
      setFormReset(() => resetFn);
    }
    if (callbackFn) {
      setFastpModalCallback(() => callbackFn);
    }
    setShowFASTPModal(true);
  };

  const closeFASTPModal = () => {
    setShowFASTPModal(false);
  };

  const store = {
    providers,
    setProviders,
    showFASTPModal,
    openFASTPModal,
    closeFASTPModal,
    originalLatitude,
    originalLongitude,
    setOriginalLatitude,
    setOriginalLongitude,
    zipCode,
    setZipCode,
    distance,
    setDistance,
    searchSeed,
    setSearchSeed,
    formReset,
    fastpModalCallback,
  };

  return <FASTPContext.Provider value={store}>{children}</FASTPContext.Provider>;
};

export default FASTPContext;

export { FASTPProvider };
